import { NextPage } from 'next'
import dynamic from 'next/dynamic'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import {
  getPpidHero,
  getPpidProcedureList,
  getPpidProcedureTitle,
  getPpidStructure,
  getPpidSubmissionList,
  getPpidSubmissionTitle,
} from '@/services/ppid'
import { wrapper } from '@/store'
const Ppid = dynamic(() => import('./Ppid'), { ssr: false })

const Page: NextPage = () => {
  return (
    <main className='min-h-screen overflow-x-hidden bg-gray-100'>
      <Ppid />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const paramsList = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  const params = {
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getPpidHero.initiate(params)),
    store.dispatch(getPpidStructure.initiate(params)),
    store.dispatch(getPpidProcedureTitle.initiate(params)),
    store.dispatch(getPpidProcedureList.initiate(paramsList)),
    store.dispatch(getPpidSubmissionTitle.initiate(params)),
    store.dispatch(getPpidSubmissionList.initiate(paramsList)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...paramsList.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'service-ppid'])),
    },
  }
})

export default Page
